import Vue from 'vue'
import Router from 'vue-router'
import utils from '@/utils/utils'
const language = utils.browserLanguage()
Vue.use(Router)
const staticPageTitle = {
  agreement: {
    zh: '隐私权政策',
    fn: '隐私权政策',
    en: '隐私权政策'
  },
  about: {
    zh: '关于名厨',
    fn: '關於名廚',
    en: 'About us'
  },
  rule: {
    zh: '协议·名厨网',
    fn: '協議·名廚	網路服務',
    en: 'GREATCHEF service agreement'
  },
  link: {
    zh: '合作联系',
    fn: '聯絡我們',
    en: 'Contact us'
  }
}
export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'articles',
      component: () => import('@/views/articles/articles')
    },
    {
      path: '/subjectview', // 老主题详情
      name: 'subject',
      component: () => import('@/views/subjectview/subjectview'),
      meta: {
        title: '主题详情'
      }
    },
    {
      path: '/themeview', // 新主题详情
      name: 'themeview',
      component: () => import('@/views/subjectview/themeview'),
      meta: {
        title: '主题详情'
      }
    },
    {
      path: '/pagview', // 新标签详情
      name: 'subject',
      component: () => import('@/views/subjectview/pagview'),
      meta: {
        title: '标签详情'
      }
    },
    { // 专题
      path: '/figure',
      name: 'figure',
      component: () => import('@/views/figure/figure')
    },
    { // 品牌认证
      path: '/brand_auth',
      name: 'brandAuth',
      component: () => import('@/views/brand/brandAuth'),
      meta: {
        title: '成为认证用户'
      }
    },
    { // 品牌认证
      path: '/country',
      name: 'country',
      component: () => import('@/views/country/index'),
      meta: { title: '地区/区号' }
    },
    {
      path: '/articlesview', // 专题
      name: 'figure',
      component: () => import('@/views/figure/figure')
    },
    {
      path: '/wikiview', // 不用测
      name: 'wiki',
      component: () => import('@/views/wiki/wiki')
    },
    // {
    // 	path: '/starclub',
    // 	name: 'club',
    // 	component:() => import('@/views/club/club'),
    // },
    {
      path: '/attestation', // 不清楚
      name: 'attestation',
      component: () => import('@/views/attestation/attestation')
    }, {
      path: '/worksview', // 不知道是个啥
      name: 'works',
      component: () => import('@/views/works/works')
    }, {
      path: '/activitiesview', // 活动
      name: 'activities',
      component: () => import('@/views/activities/activities')
    },
    {
      path: '/activity', // 活动汇总
      name: 'activity',
      component: () => import('@/views/activities/index'),
      children: [
        {
          path: 'july_activities', // 七月活动-主题联动
          name: 'july_activities',
          component: () => import('@/views/activities/julyActivities')
        },
        {
          path: 'mjMatch',
          component: () => import('@/views/activities/mjMatch'),
          meta: { title: '美极鲜生' }
        }
      ]
    },

    { // 明日之星
      path: '/tomorrow_star',
      name: 'rising',
      component: () => import('@/views/rising/rising')
    }, {
      path: '/individualview', // 不清楚
      name: 'individual',
      component: () => import('@/views/individual/individual')
    }, {
      path: '/competitionview', // 不清楚
      name: 'competition',
      component: () => import('@/views/competition/competition')
    }, {
      path: '/competitionnextview', // 不清楚
      name: 'competitionnext',
      component: () => import('@/views/competition/competitionnext')
    }, {
      path: '/competitioncancavview', // 不清楚
      name: 'competitioncancav',
      component: () => import('@/views/competition/competitioncancav')
    }, {
      path: '/adminindividualview', // 不清楚
      name: 'adminindividual',
      component: () => import('@/views/admin/individual/individual')
    }, {
      path: '/admincompetitionview', // 不清楚
      name: 'admincompetition',
      component: () => import('@/views/admin/competition/competition')
    }, {
      path: '/admincompetitionnextview', // 不清楚
      name: 'admincompetitionnext',
      component: () => import('@/views/admin/competition/competitionnext')
    }, {
      path: '/admincompetitioncancavview', // 不清楚
      name: 'admincompetitioncancav',
      component: () => import('@/views/admin/competition/competitioncancav')
    }, {
      path: '/chinesechefnextview', // 不清楚
      name: 'chinesechefnext',
      component: () => import('@/views/chinesechefnext/chinesechefnext')
    }, {
      path: '/questionnaireview', // 不清楚
      name: 'questionnaire',
      component: () => import('@/views/questionnaire/questionnaire')
    }, {
      path: '/questionnatire_success', // 不清楚
      name: 'questionnatire_success',
      component: () => import('@/views/questionnatire_success/questionnatire_success')
    }, {
      path: '/star_club', // 星级俱乐部 不需要测试
      // name: 'animation',
      component: () => import('@/views/starClub/index'),
      children: [
        {
          path: 'animation',
          component: () => import('@/views/starClub/animation'),
          meta: {
            title: '名厨星级俱乐部'
          }
        },
        {
          path: 'home',
          name: 'home',
          component: () => import('@/views/starClub/homeGift'),
          meta: {
            title: '名厨星级俱乐部'
          }
        },
        {
          path: 'receiveGift',
          name: 'receiveGift',
          component: () => import('@/views/starClub/receiveGift'),
          meta: {
            title: '领取入会礼包'
          }
        }, {
          path: 'register',
          name: 'register',
          component: () => import('@/views/starClub/register'),
          meta: {
            title: '名厨星级俱乐部'
          }
        }, {
          path: 'aboutUs',
          name: 'aboutUs',
          component: () => import('@/views/starClub/secondLevel/about'),
          meta: {
            title: '名厨星级俱乐部'
          }
        }, {
          path: 'pinpai',
          name: 'pinpai',
          component: () => import('@/views/starClub/secondLevel/pinpai'),
          meta: {
            title: '名厨星级俱乐部'
          }
        }, {
          path: 'julebu',
          name: 'julebu',
          component: () => import('@/views/starClub/secondLevel/julebu'),
          meta: {
            title: '名厨星级俱乐部'
          }
        }, {
          path: 'shangye',
          name: 'shangye',
          component: () => import('@/views/starClub/secondLevel/shangye'),
          meta: {
            title: '名厨星级俱乐部'
          }
        }, {
          path: 'ruhui',
          name: 'ruhui',
          component: () => import('@/views/starClub/secondLevel/ruhui'),
          meta: {
            title: '名厨星级俱乐部'
          }
        }, {
          path: 'huiyuan',
          name: 'huiyuan',
          component: () => import('@/views/starClub/secondLevel/huiyuan'),
          meta: {
            title: '名厨星级俱乐部'
          }
        }, {
          path: 'medalList',
          name: 'medalList',
          component: () => import('@/views/starClub/medalList.vue'),
          meta: {
            title: '勋章详情页'
          }
        }, {
          path: 'loadMore',
          name: 'loadMore',
          component: () => import('@/views/starClub/loadMore.vue'),
          meta: {
            title: '俱乐部最新动态'
          }
        }
      ]
    },
    {
      path: '/index2019',
      // name: 'cookList',
      component: () => import('@/views/cookList/index'),
      children: [{
      // 总榜
        path: '',
        // name: 'index2019',
        component: () => import('@/views/cookList/cookOfIndex/index'),
        meta: {
          title: '2019-2020名厨指数'
        }
      },
      // 品牌榜
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/cookList/brandList/index'),
        meta: {
          title: '最受关注的品牌'
        }
      },
      // 直播榜
      {
        path: 'live',
        name: 'live',
        component: () => import('@/views/cookList/liveBroadcastList/index'),
        meta: {
          title: '最受关注的直播'
        }
      },
      // 食材榜
      {
        path: 'ingredient',
        name: 'ingredient',
        component: () => import('@/views/cookList/ingredients/index'),
        meta: {
          title: '最受关注的食材'
        }
      },
      // 调味榜
      {
        path: 'condiment',
        name: 'condiment',
        component: () => import('@/views/cookList/seasoning/index'),
        meta: {
          title: '最受关注的调味品'
        }
      },
      // 中餐榜
      {
        path: 'chinese_food',
        name: 'chinese_food',
        component: () => import('@/views/cookList/chineseFoodList/index'),
        meta: {
          title: '最受关注的中餐'
        }
      },
      // 非中餐榜
      {
        path: 'non_chinese_food',
        name: 'non_chinese_food',
        component: () => import('@/views/cookList/noChineseFoodList/index'),
        meta: {
          title: '最受关注的非中餐'
        }
      },
      // 甜品榜
      {
        path: 'dessert',
        name: 'dessert',
        component: () => import('@/views/cookList/dessert/index'),
        meta: {
          title: '最受关注的甜品'
        }
      },
      // 年度出品人
      {
        path: 'author',
        name: 'author',
        component: () => import('@/views/cookList/producerOfYear/index'),
        meta: {
          title: '年度出品人'
        }
      },
      // 名厨达人
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/cookList/user/index'),
        meta: {
          title: '名厨达人'
        }
      }
      ]
    },
    {
      path: '/2020AnnualReport', // 年度报告
      component: () => import('@/views/2020AnnualReport/index'),
      children: [
        {
          path: '',
          name: '2020AnnualReport',
          component: () => import('@/views/2020AnnualReport/pages/index'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: '2020AnnualReport',
          name: '2020AnnualReport',
          component: () => import('@/views/2020AnnualReport/pages/index'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'oftenImmersed',
          name: 'oftenImmersed',
          component: () => import('@/views/2020AnnualReport/pages/oftenImmersed'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'interestedCuisine',
          name: 'interestedCuisine',
          component: () => import('@/views/2020AnnualReport/pages/interestedCuisine'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'loading',
          name: 'loading',
          component: () => import('@/views/2020AnnualReport/pages/loading'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'reportGeneration',
          name: 'reportGeneration',
          component: () => import('@/views/2020AnnualReport/pages/reportGeneration'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'myFavoriteWorks',
          name: 'myFavoriteWorks',
          component: () => import('@/views/2020AnnualReport/pages/myFavoriteWorks'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'myFavoriteWorksList',
          name: 'myFavoriteWorksList',
          component: () => import('@/views/2020AnnualReport/pages/myFavoriteWorksList'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'otherFavoriteWorks',
          name: 'otherFavoriteWorks',
          component: () => import('@/views/2020AnnualReport/pages/otherFavoriteWorks'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'otherFavoriteWorksList',
          name: 'otherFavoriteWorksList',
          component: () => import('@/views/2020AnnualReport/pages/otherFavoriteWorksList'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'follow',
          name: 'follow',
          component: () => import('@/views/2020AnnualReport/pages/follow'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'matchChefType',
          name: 'matchChefType',
          component: () => import('@/views/2020AnnualReport/pages/matchChefType'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'annualAchievements',
          name: 'annualAchievements',
          component: () => import('@/views/2020AnnualReport/pages/annualAchievements'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'missed',
          name: 'missed',
          component: () => import('@/views/2020AnnualReport/pages/missed'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'WelcomeJoin',
          name: 'WelcomeJoin',
          component: () => import('@/views/2020AnnualReport/pages/WelcomeJoin'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'WalkTogether',
          name: 'WalkTogether',
          component: () => import('@/views/2020AnnualReport/pages/WalkTogether'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'Review',
          name: 'Review',
          component: () => import('@/views/2020AnnualReport/pages/Review'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'Open',
          name: 'Open',
          component: () => import('@/views/2020AnnualReport/pages/Open'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'CreationTimes',
          name: 'CreationTimes',
          component: () => import('@/views/2020AnnualReport/pages/CreationTimes'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'noCreation',
          name: 'noCreation',
          component: () => import('@/views/2020AnnualReport/pages/noCreation'),
          meta: {
            title: '2020年度名厨报告'
          }
        }, {
          path: 'agreement',
          name: 'agreement',
          component: () => import('@/views/2020AnnualReport/pages/agreement'),
          meta: {
            title: '2020年度名厨报告'
          }
        }
      ]
    },
    {
      path: '/2020mcindex', // 年度榜单
      name: '2020mcindex',
      component: () => import('@/views/2020index/index'),
      children: [
        { // 总榜
          path: '',
          name: 'index2020',
          component: () => import('@/views/2020index/home/index'),
          meta: {
            title: '2020-2021名厨指数'
          }
        },
        { // 食材
          path: 'foodPage',
          name: 'foodPage',
          component: () => import('@/views/2020index/foodPage/index'),
          meta: {
            title: '2020-2021名厨指数'
          }
        },
        { // 人物
          path: 'userPage',
          name: 'userPage',
          component: () => import('@/views/2020index/userPage/index'),
          meta: {
            title: '2020-2021名厨指数'
          }
        },
        { // 品牌
          path: 'brandPage',
          name: 'brandPage',
          component: () => import('@/views/2020index/brandPage/index'),
          meta: {
            title: '2020-2021名厨指数'
          }
        },
        { // 作品
          path: 'workPage',
          name: 'workPage',
          component: () => import('@/views/2020index/workPage/index'),
          meta: {
            title: '2020-2021名厨指数'
          }
        },
        { // 视频
          path: 'videoPage',
          name: 'videoPage',
          component: () => import('@/views/2020index/videoPage/index'),
          meta: {
            title: '2020-2021名厨指数'
          }
        },
        { // 投票
          path: 'votePage',
          name: 'votePage',
          component: () => import('@/views/2020index/votePage/index'),
          meta: {
            title: '2020-2021名厨指数'
          }
        }
      ]
    },
    {
      path: '/staticPage', // 老的原生html转vue页面
      component: () => import('@/views/staticPage/index'),
      children: [
        {
          path: '',
          name: 'agreement',
          component: () => import('@/views/staticPage/pages/agreement'),
          meta: {
            title: staticPageTitle.agreement[language]
          }
        },
        {
          path: 'agreement',
          name: 'agreement',
          component: () => import('@/views/staticPage/pages/agreement'),
          meta: {
            title: staticPageTitle.agreement[language]
          }
        }, {
          path: 'rule',
          name: 'rule',
          component: () => import('@/views/staticPage/pages/rule'),
          meta: {
            title: staticPageTitle.rule[language]
          }
        }, {
          path: 'about',
          name: 'about',
          component: () => import('@/views/staticPage/pages/about'),
          meta: {
            title: staticPageTitle.about[language]
          }
        }, {
          path: 'link',
          name: 'link',
          component: () => import('@/views/staticPage/pages/link'),
          meta: {
            title: staticPageTitle.link[language]
          }
        }
      ]
    },
    { // // 老的原生html转vue页面
      path: '/htmlPage',
      component: () => import('@/views/htmlChangeVue/index'),
      children: [
        {
          path: 'invite',
          name: 'invite',
          component: () => import('@/views/htmlChangeVue/invite/index'),
          meta: {}
        },
        {
          path: 'inviteRegister',
          name: 'inviteRegister',
          component: () => import('@/views/htmlChangeVue/shareInvite/index'),
          meta: {}
        }

      ]
    },
    {
      path: '/markdown',
      name: 'markdown',
      component: () => import('@/views/markdown/index'),
      meta: {}
    },
    { // 认证
      path: '/auth',
      component: () => import('@/views/auth/index'),
      redirect: '/auth/home',
      children: [
        {
          path: 'home', // 实名认证
          name: 'home',
          component: () => import('@/views/auth/publice/home'),
          meta: { title: '认证主页' }
        },
        {
          path: 'status', // 认证状态
          name: 'status',
          component: () => import('@/views/auth/publice/status'),
          meta: { title: '认证状态' }
        },
        {
          path: 'position', // 选择职位
          name: 'position',
          component: () => import('@/views/auth/publice/position'),
          meta: { title: '选择职位' }
        },
        {
          path: 'nameAuth', // 实名认证
          name: 'nameAuth',
          component: () => import('@/views/auth/nameAuth/index'),
          redirect: '/auth/nameAuth/aiForm',
          meta: { title: '实名认证' },
          children: [
            {
              path: 'aiForm', // 人脸表单
              name: 'aiForm',
              component: () => import('@/views/auth/nameAuth/aiAuth/form'),
              meta: { title: '扫脸认证' }
            },
            {
              path: 'aiConfirm', // 人脸确认
              name: 'aiConfirm',
              component: () => import('@/views/auth/nameAuth/aiAuth/confirm'),
              meta: { title: '扫脸认证' }
            },
            {
              path: 'scanFace', // 扫脸
              name: 'scanFace',
              component: () => import('@/views/auth/nameAuth/aiAuth/scanFace'),
              meta: { title: '扫脸认证' }
            },
            {
              path: 'normalAuth', // 人工审核认证
              name: 'normalAuth',
              component: () => import('@/views/auth/nameAuth/normalAuth/form'),
              meta: { title: '人工审核' }
            }
          ]
        },
        {
          path: 'opnAuth', // 职业认证
          name: 'opnAuth',
          component: () => import('@/views/auth/occupationAuth/index'),
          redirect: '/auth/opnAuth/home',
          meta: { title: '职业认证' },
          children: [
            {
              path: 'home', // 职业认证主页
              name: 'home',
              component: () => import('@/views/auth/occupationAuth/home'),
              meta: { title: '职业认证' }
            },
            {
              path: 'form', // 职业认证表单
              name: 'form',
              component: () => import('@/views/auth/occupationAuth/form'),
              meta: { title: '职业认证' }
            }
          ]
        },
        {
          path: 'brandAuth', // 企业认证
          name: 'brandAuth',
          component: () => import('@/views/auth/enterpriseAuth/index'),
          meta: { title: '企业认证' }
        }
      ]
    },
    {
      path: '/bigEvent', // 大事件
      name: 'bigEvent',
      component: () => import('@/views/bigEvent/index'),
      redirect: '/bigEvent/home',
      meta: { title: '大事件' },
      children: [
        {
          path: 'home', // 主页活动管理
          name: 'home',
          component: () => import('@/views/bigEvent/home')
        },
        {
          path: 'homeDetail', // 主页活动管理详情
          name: 'homeDetail',
          component: () => import('@/views/bigEvent/homeDetail')
        },
        {
          path: 'publish', // 发布列表
          name: 'publish',
          component: () => import('@/views/bigEvent/publish')
        },
        {
          path: 'formStep1', // 发布表单第一步
          name: 'formStep1',
          component: () => import('@/views/bigEvent/publish/formStep1')
        },
        {
          path: 'formStep2', // 发布表单第二步
          name: 'formStep2',
          component: () => import('@/views/bigEvent/publish/formStep2')
        },
        {
          path: 'nameList', // 发布获奖名单
          name: 'nameList',
          component: () => import('@/views/bigEvent/publish/nameList')
        },
        {
          path: 'sharePoster', // 分享的海报
          name: 'sharePoster',
          component: () => import('@/views/bigEvent/publish/sharePoster')
        },
        {
          path: 'joinDetail', // 参与活动详情
          name: 'joinDetail',
          component: () => import('@/views/bigEvent/joinDetail')
        },
        {
          path: 'activeDetail', // 活动详情
          name: 'activeDetail',
          component: () => import('@/views/bigEvent/activeDetail')
        }
      ]
    },
    {
      path: '/michelin', // 米其林活动
      name: 'michelin',
      component: () => import('@/views/michelin/index'),
      redirect: '/michelin/home',
      children: [
        {
          path: 'home', // 米其林活动主页
          name: 'home',
          component: () => import('@/views/michelin/home'),
          meta: { title: '线上米其林' }
        },
        {
          path: 'introduce', // 米其林活动介绍
          name: 'introduce',
          component: () => import('@/views/michelin/introduce'),
          meta: { title: '介绍' }
        }
      ]
    }
  ]
})
